import { render, staticRenderFns } from "./forMobile.vue?vue&type=template&id=6c462221&lang=html"
import script from "./forMobile.vue?vue&type=script&lang=js"
export * from "./forMobile.vue?vue&type=script&lang=js"
import style0 from "./forMobile.vue?vue&type=style&index=0&id=6c462221&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports